import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const QUICK_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact Us', path: '/contact' },
];

const SERVICE_LINKS = [
  { label: 'Wedding', path: '/wedding' },
  { label: 'Fashion', path: '/fashion' },
  { label: 'Events', path: '/events' },
  { label: 'Commercial', path: '/commercial' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="relative bg-visyra-paper border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16 sm:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" data-testid="footer-logo" className="inline-flex items-baseline gap-0 group mb-5">
              <span className="font-heading text-gold text-3xl sm:text-4xl italic tracking-tight group-hover:text-gold-light transition-colors duration-300">V</span>
              <span className="font-heading text-visyra-text text-2xl sm:text-3xl tracking-tight group-hover:text-gold-light transition-colors duration-300">isyra</span>
            </Link>
            <p className="font-body text-sm text-visyra-muted leading-relaxed max-w-xs">
              Premium photography and cinematography brand. Crafting visual stories that last a lifetime.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-visyra-dim mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="font-body text-sm text-visyra-muted hover:text-gold transition-colors duration-300 gold-underline">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-visyra-dim mb-5">Services</h4>
            <ul className="space-y-3">
              {SERVICE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} data-testid={`footer-service-${link.label.toLowerCase()}`}
                    className="font-body text-sm text-visyra-muted hover:text-gold transition-colors duration-300 gold-underline">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.2em] text-visyra-dim mb-5">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:visyramediaproductions@gmail.com" data-testid="footer-email"
                  className="font-body text-sm text-visyra-muted hover:text-gold transition-colors duration-300 flex items-center gap-1">
                  visyramediaproductions@gmail.com<ArrowUpRight size={12} className="text-gold/50" />
                </a>
              </li>
              <li>
                <a href="tel:+918073504269" data-testid="footer-phone"
                  className="font-body text-sm text-visyra-muted hover:text-gold transition-colors duration-300 flex items-center gap-1">
                  +91 80735 04269 <ArrowUpRight size={12} className="text-gold/50" />
                </a>
              </li>
              <li>
                <a href="https://wa.me/918073504269" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp"
                  className="font-body text-sm text-visyra-muted hover:text-gold transition-colors duration-300 flex items-center gap-1">
                  WhatsApp <ArrowUpRight size={12} className="text-gold/50" />
                </a>
              </li>
              <li>
                <p className="font-body text-sm text-visyra-muted">Bangalore, Karnatake, India</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p data-testid="footer-copyright" className="font-body text-xs text-visyra-dim">
            &copy; 2024 Visyra. All rights reserved.
          </p>
          <p className="font-body text-xs text-visyra-dim">Crafted with passion & precision</p>
        </div>
      </div>
    </footer>
  );
}
